import {useTranslation} from "react-i18next";
import type {InsightsLoading} from "../../kit/insightsLoading";
import type {InsightRankedGuestV4} from "../../models/crm-v4";
import RankedGuestTable from "./RankedGuestTable";
import {useRankedGuestTableActions} from "./useRankedGuestTableActions";

interface MostReservationsTableProps {
    rows: InsightRankedGuestV4[];
    comparisonRows?: InsightRankedGuestV4[];
    loading?: InsightsLoading;
}

export function MostReservationsTable({rows, comparisonRows, loading}: MostReservationsTableProps) {
    const {t, i18n} = useTranslation();
    const countFormatter = new Intl.NumberFormat(i18n.resolvedLanguage || i18n.language, {
        maximumFractionDigits: 0,
    });
    const actions = useRankedGuestTableActions("MOST_RESERVATIONS");

    return (
        <RankedGuestTable
            title={t("Most reservations")}
            hint={t("Guests arriving in the selected period, ranked by their lifetime reservation count.")}
            valueLabel={t("Reservations")}
            rows={rows}
            comparisonRows={comparisonRows}
            loading={loading}
            formatValue={value => countFormatter.format(value)}
            {...actions}
        />
    );
}

export default MostReservationsTable;
